export const GET_EVENT = 'GET_EVENT';
export const EVENT_LOADING = 'EVENT_LOADING';
export const GET_EVENTS = 'GET_EVENTS';
export const EVENTS_LOADING = 'EVENTS_LOADING';
export const GET_EVENTS_TYPES = 'GET_EVENTS_TYPES';
export const GET_EVENTS_PUBLICS = 'GET_EVENTS_PUBLICS';
export const TAXONOMIES_LOADING = 'TAXONOMIES_LOADING';
export const SET_EVENTS_SEARCH_CRITERIA = 'SET_EVENTS_SEARCH_CRITERIA';
export const RESET_EVENTS_SEARCH_CRITERIA = 'RESET_EVENTS_SEARCH_CRITERIA';
export const SIGNUP_TO_EVENT = 'SIGNUP_TO_EVENT';
export const SIGNOUT_FROM_EVENT = 'SIGNOUT_FROM_EVENT';
export const SIGNUPOROUT_TO_EVENT_LOADING = 'SIGNUPOROUT_TO_EVENT_LOADING';
export const SIGNUPOROUT_TO_EVENT_FAILURE = 'SIGNUPOROUT_TO_EVENT_FAILURE';
export const DASHBOARD_GET_EVENTS_CHECKEDIN = 'DASHBOARD_GET_EVENTS_CHECKEDIN';
export const DASHBOARD_GET_EVENTS_AUTHOR = 'DASHBOARD_GET_EVENTS_AUTHOR';
export const DASHBOARD_GET_EVENTS_LOADING = 'DASHBOARD_GET_EVENTS_LOADING';
export const SET_CURRENT_USER_SUBSCRIBED = 'SET_CURRENT_USER_SUBSCRIBED';
export const TOGGLE_DIALOG_SUBSCRIBE = 'TOGGLE_DIALOG_SUBSCRIBE';
export const TOGGLE_DIALOG_SUBSCRIBE_SUCCESS = 'TOGGLE_DIALOG_SUBSCRIBE_SUCCESS';
export const TOGGLE_DIALOG_UNSUBSCRIBE = 'TOGGLE_DIALOG_UNSUBSCRIBE';
export const TOGGLE_DIALOG_UNSUBSCRIBE_SUCCESS = 'TOGGLE_DIALOG_UNSUBSCRIBE_SUCCESS';
export const TOGGLE_DIALOG_UPDATE_SUBSCRIBE = 'TOGGLE_DIALOG_UPDATE_SUBSCRIBE';
export const TOGGLE_DIALOG_UPDATE_SUBSCRIBE_SUCCESS = 'TOGGLE_DIALOG_UPDATE_SUBSCRIBE_SUCCESS';
export const UI_REMEMBER_SCROLL_POSITION_LISTING = 'UI_REMEMBER_SCROLL_POSITION_LISTING';
export const UI_REMEMBER_PAGINATION_LISTING = 'UI_REMEMBER_PAGINATION_LISTING';


// WEBPACK FOOTER //
// ./src/features/Events/types.js